import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useState } from 'react';
const TabFocus = memo(({ children }) => {
    const [showOutline, setShowOutline] = useState(false);
    useEffect(() => {
        const disableOutline = () => {
            setShowOutline(false);
        };
        const enableOutline = (e) => {
            if (e.key === 'Tab')
                setShowOutline(true);
        };
        window.addEventListener('pointermove', disableOutline);
        window.addEventListener('keydown', enableOutline);
        return () => {
            window.removeEventListener('pointermove', disableOutline);
            window.removeEventListener('keydown', enableOutline);
        };
    }, [setShowOutline]);
    return (_jsx("div", { className: showOutline ? undefined : 'hide-tab-focus', children: children }));
});
TabFocus.displayName = 'TabFocus';
export default TabFocus;
